module.exports = __webpack_public_path__ + "static/img/firebase.b0c12b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/discover/firebase.png
// module id = GTp/
// module chunks = 1